import { gql, useQuery } from "@apollo/client";
import {
  ViewIndustryQueryQuery,
  ViewIndustryQueryQueryVariables,
  Industry
} from "../../../../schemaTypes";

export const viewIndustryQuery = gql`
  query ViewIndustryQuery($id: String!) {
    viewIndustry(id: $id) {
      id
      name
      createdAt
      updatedAt
      isArchive
      partnerCount
      createdBy {
        id
        admin{
          id
          firstname
          lastname
          email
          level
        }
      }
    }
  }
`;

export function useViewIndustry(id: string) {
  const { data, loading, error } = useQuery<
    ViewIndustryQueryQuery,
    ViewIndustryQueryQueryVariables
  >(viewIndustryQuery, {
    variables: { id },
    skip: !id,
  });

  return {
    industry: data?.viewIndustry as Industry | undefined,
    loading,
    error
  };
}
